import { createEndpoint } from '@/shared/models/api';
import { IdValue } from '@/app/api/morgan-thermal';

export type Casing = IdValue;

export const getCasings = createEndpoint<Casing[]>(({ fetch }) => () => fetch('/Configuration/GetCasings'));